module.exports = __webpack_public_path__ + "resources/img/img_edb_1_m_jp.d5bb627e2c749631735b3ac220adf2f5.png";